export default __webpack_public_path__ + "static/media/prodiamine-award.c2e6ead1.png";